import SearchableSelect from './SearchableSelect';
import { jobDisplayLabel, jobSearchText } from './entitySearchLabels';

export default function SearchableJobSelect({
  jobs = [],
  value,
  onChange,
  placeholder = 'Search by title, client, location, or ID…',
  allowEmpty = false,
  emptyLabel = '',
  compact = false,
  showHint = true,
  className = ''
}) {
  return (
    <SearchableSelect
      items={jobs}
      value={value}
      onChange={onChange}
      getValue={j => j.id}
      getLabel={jobDisplayLabel}
      getSearchText={jobSearchText}
      placeholder={placeholder}
      hint="Search by job title, client, location, or ID"
      showHint={showHint && !compact}
      allowEmpty={allowEmpty}
      emptyLabel={emptyLabel}
      compact={compact}
      className={className}
      clearAriaLabel="Clear job"
    />
  );
}
